export default "__VITE_ASSET__GIdjZadt__"